import { landingThemes, LandingThemePalette } from './landingThemes';
import type React from 'react';

export const DM = landingThemes[1]!;

function makeThemeVars(t: LandingThemePalette): React.CSSProperties {
  return {
    ['--lt-bg' as string]: t.background,
    ['--lt-surface' as string]: t.surface,
    ['--lt-accent' as string]: t.accent,
    ['--lt-text' as string]: t.text,
    ['--lt-muted' as string]: t.textMuted,
    ['--lt-border' as string]: t.border,
    ['--lt-nav-bg' as string]: t.navBg,
    ['--lt-nav-border' as string]: t.navBorder,
    ['--lt-card-bg' as string]: t.cardBg,
    ['--lt-card-border' as string]: t.cardBorder,
    ['--lt-tag-bg' as string]: t.tagBg,
    ['--lt-tag-text' as string]: t.tagText,
  };
}

/** Marketplace directory is always locked to Dream Market (light). */
export const SHOP_DM_VARS: React.CSSProperties = makeThemeVars(DM);

/** Returns the theme palette + CSS vars for a boutique by its stored themeIndex. Falls back to Dream Market. */
export function getBoutiqueThemeVars(themeIndex?: number): { theme: LandingThemePalette; vars: React.CSSProperties } {
  const theme = landingThemes[themeIndex ?? 1] ?? DM;
  return { theme, vars: makeThemeVars(theme) };
}
